<template>
  <transition name="fade">
    <div class="box-cookies" v-if="modalStatus">
      <div class="container">
        <div class="row row-responsive -vertical-align">
          <div class="column column-sm-75">
            <b class="title">Políticas de cookies:</b>
            Utilizamos cookies propias y de terceros para ofrecerte una mejor experiencia y servicio, de acuerdo a tus hábitos de navegación. Puedes obtener más información en nuestra <a href="/static/pdf/politicas-privacidad-mx.pdf" target="_blank">Políticas de privacidad</a> y en <a href="/static/pdf/terminos-condiciones-mx.pdf" target="_blank">Términos y condiciones</a>.
          </div>
          <div class="column column-sm-25">
            <button class="button button-action button-small" @click="writeCookies()" title="Aceptar">Aceptar</button>
            <button class="button button-small button-close" @click="closeModal()" title="Cerrar">Cerrar</button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'CookiesMessage',
  data () {
    return {
      cookies: false,
      modalStatus: true
    }
  },
  methods: {
    readCookies: function () {
      this.cookies = localStorage.getItem('sofom_cookies')
      if (this.cookies) {
        this.closeModal()
      }
    },
    writeCookies: function () {
      localStorage.setItem('sofom_cookies', true)
      this.closeModal()
    },
    closeModal: function () {
      this.modalStatus = false
    }
  },
  created: function () {
    this.readCookies()
  }
}
</script>

<style lang="scss" scoped>

.box-cookies {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 2rem 0;
  color: $white;
  font-size: .9em;
  background-color: $midnight-blue;
  box-shadow: 0 -4px 5px rgba(0, 0, 0, 0.1);
  z-index: 9;

  .title {
    display: block;
  }

  a:hover {
    color: $green;
    text-decoration: underline;
  }

  .button-close {
    $color: #666;

    margin-top: 2rem;
    margin-left: 1rem;
    background-color: $color;
    border-color: $color;
  }
}
</style>



// WEBPACK FOOTER //
// src/partials/CookiesMessage.vue